import { Zap } from "lucide-react";
import { Button } from "./ui/button";

const UrgencyBanner = () => {
  return (
    <div className="bg-gradient-to-r from-primary/20 via-accent/20 to-primary/20 border-y border-primary/30 py-4 px-4 mb-8">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center animate-pulse">
            <Zap className="w-5 h-5 text-primary" />
          </div>
          <div>
            <p className="font-bold text-foreground text-lg">
              ⚡ This Month Only – Limited Availability
            </p>
            <p className="text-sm text-muted-foreground">
              Free AI System Audit for New Clients (Value: $299)
            </p>
          </div>
        </div>
        
        <Button
          asChild
          size="lg"
          className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold rounded-xl px-6 shadow-[0_0_20px_rgba(0,255,200,0.4)] hover:shadow-[0_0_30px_rgba(0,255,200,0.6)] transition-all whitespace-nowrap"
        >
          <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
            Claim Your Free Audit
          </a>
        </Button>
      </div>
    </div>
  );
};

export default UrgencyBanner;
